import { Button, Dialog, DialogContent, DialogContentText } from '@mui/material';



export default function AlertDialog(props: any) {

    const {
        open, 
        setOpen, 
        title = 'Confirm',
        send, 
        subtitle
    } = props;

    

  
  return (
    <>
        {/* ALERT DIALOG */}
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
                <DialogContent  className="forced_box_editor">
                <div className="dialog_header">
                    <h2 className='dialog_h2'>{title}</h2>
                    <DialogContentText>
                        {subtitle? subtitle : 'Are you sure you want to proceed?'}
                    </DialogContentText>
                </div>

                <div className="buttons">
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpen(false)}
                    >
                        Cancel
                    </Button>
                    
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setOpen(false);
                            send()
                        }}
                    >
                        Confirm
                    </Button>

                </div>

                </DialogContent>
            </Dialog>

    </>
  );
};

